import data from "../../../../../packages/react/src/AvatarPair/AvatarPair.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};